let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iCBBr")).then(() => parcelRequire('fIxO7'));